module.exports = {render:function anonymous() {
with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","aria-labelledby":"handle","viewBox":"0 0 256 256"}},[_c('path',{attrs:{"d":"M104.868 70.438h46.265V24.711h-46.265zm46.265 80.694v-46.265h-46.265v46.265zm0 80.157v-45.727h-46.265v45.727z"}})])}
}};